import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const COLORS = { active: "#2ECA7F", off: "#64748B", no_data: "#FBBF24" };

export const SymbolsCard = () => {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    api.get("/mt5admin/brain/symbols").then((r) => setRows(r.data.symbols || [])).catch(() => {});
  }, []);
  const toggle = async (s) => {
    setBusy(s.symbol);
    try {
      const r = await api.post("/mt5admin/brain/symbols", { symbol: s.symbol, enabled: s.status !== "active" });
      setRows(r.data.symbols || []);
    } finally {
      setBusy("");
    }
  };
  const focus = async () => {
    setBusy("focus");
    try {
      const r = await api.post("/mt5admin/brain/symbols/focus?n=6");
      setRows(r.data.symbols || []);
    } finally {
      setBusy("");
    }
  };
  return (
    <div data-testid="symbols-card" className="mt-8 border border-[#A78BFA]/30 rounded-lg p-5 bg-[#0B0D14]">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
        <div className="text-lg font-medium">Symbols the brain works on</div>
        <div className="flex items-center gap-3">
          <div className="mono text-[10px] uppercase tracking-widest text-[#64748B]">
            click to switch on/off · amber = no tester data (auto-skipped, click to retry)
          </div>
          <button data-testid="symbols-focus-btn" onClick={focus} disabled={busy === "focus"}
            className="mono text-[10px] uppercase tracking-widest px-3 py-1.5 rounded-full border border-[#A78BFA]/60 text-[#A78BFA] hover:bg-[#A78BFA]/10 transition-colors disabled:opacity-50">
            Focus best 6
          </button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {rows.map((s) => (
          <button key={s.symbol} data-testid={`symbol-toggle-${s.symbol}`} disabled={busy === s.symbol}
            onClick={() => toggle(s)}
            className="mono text-[11px] px-3 py-1.5 rounded-full border transition-colors hover:bg-[#111827] disabled:opacity-50"
            style={{ borderColor: `${COLORS[s.status]}88`, color: COLORS[s.status] }}
            title={`${s.status} · ${s.tests} tests · ${s.proven} proven`}>
            {s.symbol}
            <span className="ml-2 text-[9px] text-[#64748B]">{s.status === "no_data" ? "no data" : s.status} · {s.tests}</span>
            {s.proven > 0 && <span className="ml-1 text-[9px] text-[#2ECA7F]">✓{s.proven}</span>}
          </button>
        ))}
      </div>
    </div>
  );
};
